import { units } from '@ui/css';
import { combineTokens, makeSelectors } from '@utils/css';

const transitionDurationMs = {
  enter: 200,
  exit: 200
};
const dialogTokens = combineTokens("--dialog", {
  maxHeight: `calc(${units.vh(100)} - ${units.px(60)})`,
  maxWidth: `calc(${units.vw(100)} - ${units.px(60)})`
});
const wrapper = "dibw1fp1ztf";
const dialog = "dibd5hvs0";
const scrollContainer = "dibs1pdsyrj";
const speechButton = "dibs1gdlrjw";
const backdrop = "dibbv4l5ck";
const dialogSelectors = makeSelectors({
  wrapper,
  dialog,
  backdrop,
  scrollContainer,
  speechButton
});

export { backdrop, dialog, dialogSelectors, dialogTokens, scrollContainer, speechButton, transitionDurationMs, wrapper };
import "./dialog.style.linaria.module.css";
//# sourceMappingURL=dialog.style.js.map
